const ONETRUST_BANNER_ID = 'onetrust-banner-sdk';

let bannerResizeObserver = null;
let bannerMutationObserver = null;
const subscribers = new Set();
let currentHeight = 0;

function notifySubscribers() {
    subscribers.forEach(cb => cb(currentHeight));
}

function attachResizeObserver(banner) {
    bannerResizeObserver = new ResizeObserver(entries => {
        const height = entries[0]?.contentRect?.height ?? 0;
        if (height !== currentHeight) {
            currentHeight = height;
            notifySubscribers();
        }
    });
    bannerResizeObserver.observe(banner);

    // Sync immediately rather than waiting for the first ResizeObserver callback,
    // which only fires on the next paint.
    const initialHeight = banner.getBoundingClientRect().height;
    if (initialHeight !== currentHeight) {
        currentHeight = initialHeight;
        notifySubscribers();
    }
}

function start() {
    const banner = document.getElementById(ONETRUST_BANNER_ID);
    if (banner) {
        attachResizeObserver(banner);
        return;
    }

    // OneTrust injects the banner asynchronously — watch for it to appear.
    bannerMutationObserver = new MutationObserver(() => {
        const b = document.getElementById(ONETRUST_BANNER_ID);
        if (b) {
            bannerMutationObserver.disconnect();
            bannerMutationObserver = null;
            attachResizeObserver(b);
        }
    });
    bannerMutationObserver.observe(document.body, { childList: true });
}

function stop() {
    bannerResizeObserver?.disconnect();
    bannerResizeObserver = null;
    bannerMutationObserver?.disconnect();
    bannerMutationObserver = null;
    currentHeight = 0;
}

/**
 * Subscribes to live height changes of the OneTrust consent banner.
 * Uses a singleton observer so multiple callers share a single ResizeObserver.
 * Returns an unsubscribe function.
 */
export function subscribeToOneTrustBannerHeight(callback) {
    subscribers.add(callback);

    if (subscribers.size === 1) {
        start();
    }

    // Notify immediately if the banner is already measured.
    if (currentHeight > 0) {
        callback(currentHeight);
    }

    return () => {
        subscribers.delete(callback);
        if (subscribers.size === 0) {
            stop();
        }
    };
}
